import { render } from "./DeclaracionResponsable.vue?vue&type=template&id=e304b9a2&ts=true"
import script from "./DeclaracionResponsable.vue?vue&type=script&lang=ts"
export * from "./DeclaracionResponsable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__